import { AbstractControl, Validators, ValidatorFn } from '@angular/forms';

import { isPresent } from '../utils';

export const bic: ValidatorFn = (control: AbstractControl): {[key: string]: any} => {
  if (isPresent(Validators.required(control))) {
    return null;
  }

  const v: string = control.value.replace(/[^A-Z0-9]/g, '');

  return /^([a-zA-Z]{4})([a-zA-Z]{2})([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})?$/.test(v)
    ? null
    : {
      bic: true,
      requiredValue: '',
      actualValue: v,
    };
};
